module.exports = "﻿﻿<div class=\"middle-box text-center loginscreen  animated fadeInDown\">\r\n    <div>\r\n        <div>\r\n            <h1 class=\"logo-name\">B2B</h1>\r\n        </div>\r\n        <h3>Logging you out...</h3>\r\n        <p>If you are not redirected within 5 seconds please <a [routerLink]=\"['/dashboard']\">click here</a></p>.\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/userAccounts/log.out.successful.component.html
// module id = 1260
// module chunks = 0